import useCreateMarkup from 'components/Dashboard/hooks/useCreateMarkup';
import time from 'utils/time';

const CrmInteractionNewContent = (props) => {
  const { currentNew, reportWidget } = props;
  const { title, interactionType, dateTime, addedByUserFullName, description, htmlBody, crmContactNames } =
    currentNew ?? {};

  const isEmailType = /email/i.test(interactionType);

  const { createMarkup } = useCreateMarkup();

  return (
    <>
      <div
        className={`section-title pb-2 ${
          reportWidget ? 'content-title-in-widget' : 'content-title-with-summary'
        } content-border-title`}
      >
        <h3 className='main-title news-title bg-white content-item-title'>{title}</h3>
        <p className='heading-date mb-0'>
          {interactionType && (
            <>
              <span>{interactionType}</span>
              <span className='dot'></span>
            </>
          )}
          {addedByUserFullName && (
            <>
              <span>{addedByUserFullName}</span>
              <span className='dot'></span>
            </>
          )}
          {!isEmailType && crmContactNames?.length > 0 && (
            <>
              <span>
                {crmContactNames.length} stakeholder{crmContactNames.length > 1 ? 's' : ''}
              </span>
              <span className='dot'></span>
            </>
          )}
          {dateTime && <span className='date'>{time(dateTime).formatLongDate()}</span>}
        </p>
      </div>
      <div className='pt-3 news-content-in parliamentary-content-in context'>
        {(htmlBody || description) && (
          <div className='debate-item-contributiondebateitem'>
            <div dangerouslySetInnerHTML={createMarkup(htmlBody || description)} />
          </div>
        )}
      </div>
    </>
  );
};

export default CrmInteractionNewContent;
